// extracted by mini-css-extract-plugin
export default {"container":"qBZgw","title":"n2qk8"};